module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/eo-sg/tab-9fffdd39337e55ed97a50024a5987abb.png";